import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { MFChannel } from '../../../Components/SDK';
import { setActiveConversationChannel, useChannelIsMember } from '../../../slice';
import { showErrorToast } from '../../utils';
import { navigateChannel } from '../../../shell/Sidebar';
import logger from '../../../Helpers/logger';

function ChannelJoinButton({ channelId, _className }) {
    const isMember = useChannelIsMember(channelId);
    const dispatch = useDispatch();
    const handleJoin = async () => {
        try {
            const res = await MFChannel.joinChannel({ channelId });
            if (res.statusCode !== 200) {
                showErrorToast(res?.message);
                return;
            }
            setTimeout(() => {
                navigateChannel?.current?.toRecentChannels();
                dispatch(setActiveConversationChannel({ channelId }));
            }, 300);
        } catch (error) {
            logger.error('❌ Failed to join channel:', error);
        }
    };

    return (
        <a key={channelId} disabled={isMember} onClick={handleJoin}>
            {isMember ? 'Followed' : 'Follow'}
        </a>
    );
}

export default ChannelJoinButton;

ChannelJoinButton.propTypes = {
    channelId: PropTypes.string.isRequired,
    className: PropTypes.string,
};
